import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { CountryInfo, CurrencyInfo, ToastMessage } from '@/types/common';

export default function useAppData() {
  const appName = computed<string>(() => usePage().props.appName as string);
  const stripeKey = computed<string>(() => usePage().props.stripeKey as string);
  const stateLabel = computed<string>(() => usePage().props.stateLabel as string);
  const country = computed<CountryInfo>(() => usePage().props.country as CountryInfo);
  const previousUrl  = computed<string>(() => (usePage().props.previousUrl) as string);
  const appCurrency = computed<CurrencyInfo>(() => usePage().props.currency as CurrencyInfo);
  const mobileNumberLabel = computed<string>(() => usePage().props.mobileNumberLabel as string);
  const toastMessage = computed<ToastMessage>(() => usePage().props.toastMessage as ToastMessage);
  const disableChatbot = computed<boolean>(() => usePage().props.flash.disable_chatbot as boolean);
  const currencyInputLocale = computed<string>(() => usePage().props.currencyInputLocale as string);
  const appLocale = computed<string>(() => document.getElementsByTagName('html')[0].getAttribute('lang'));
  const errorMessage = computed<string|null>(() => usePage().props.flash.error_message as string|null);
  const toolsFeatures = computed<{ [key: string]: boolean }>(() => usePage().props.toolsFeatures as { [key: string]: boolean });
  const anyToolsFeatureEnabled = computed<boolean>(() => Object.values(toolsFeatures.value).some((value: boolean) => value === true));
  const canUpgradeCurrentSubscriptionPlan = computed<boolean>(() => usePage().props.canUpgradeCurrentSubscriptionPlan as boolean);

  return {
    appName,
    country,
    appLocale,
    stripeKey,
    stateLabel,
    appCurrency,
    previousUrl,
    toastMessage,
    errorMessage,
    toolsFeatures,
    disableChatbot,
    mobileNumberLabel,
    currencyInputLocale,
    anyToolsFeatureEnabled,
    canUpgradeCurrentSubscriptionPlan,
  };
}
